import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels'; // opcional

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  // ChartDataLabels
);

const GraficaFrecuenciaClientes = ({ data }) => {
  //console.log("📥 Datos recibidos para clientes:", data);

  // 🧹 Validación defensiva y limpieza
  const clientes = Array.isArray(data)
    ? data.map((nombre, i) => {
        const limpio = nombre?.trim();
       // console.log(`[${i}] cliente:`, limpio);
        return limpio;
      }).filter(v => v)
    : [];

  if (clientes.length === 0) {
   // console.warn("⚠️ No se encontraron clientes válidos.");
  }

  // 📊 Agrupamos por cliente
  const frecuencia = {};
  clientes.forEach(nombre => {
    frecuencia[nombre] = (frecuencia[nombre] || 0) + 1;
  });

  //console.log("📊 Frecuencia agrupada por cliente:", frecuencia);

  const labels = Object.keys(frecuencia).sort(); // orden alfabético
  const valores = labels.map(k => frecuencia[k]);

  // 🎨 Colores institucionales
  const backgroundColor = labels.map(() => '#99ccff');
  const borderColor = labels.map(() => '#3399ff');

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Frecuencia por Cliente',
        data: valores,
        backgroundColor,
        borderColor,
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: context => `Repeticiones: ${context.raw}`
        }
      },
      // datalabels: {
      //   anchor: 'end',
      //   align: 'top',
      //   color: '#000',
      //   font: {
      //     weight: 'bold',
      //     size: 12
      //   },
      //   formatter: value => value
      // }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Cantidad' }
      },
      x: {
        title: { display: true, text: 'Cliente' },
        ticks: {
          callback: val => labels[val]?.length > 25
            ? labels[val].slice(0, 25) + '…'
            : labels[val]
        }
      }
    }
  };

  return (
    <div style={{ maxWidth: '900px', margin: '2rem auto' }}>
      <h4 style={{ textAlign: 'center', marginBottom: '1rem' }}>
        Frecuencia por Cliente
      </h4>
      {labels.length > 0 ? (
        <Bar data={chartData} options={options} />
      ) : (
        <p style={{ textAlign: 'center', color: '#999' }}>
          No hay datos válidos para mostrar.
        </p>
      )}
    </div>
  );
};

export default GraficaFrecuenciaClientes;